export const balanceText = () => {
  const balance = document.querySelector('.balance__items')
  const lines = document.querySelectorAll('.balance__item')

  if (!balance) return

  const tiltBalanceEl = (mouseX) => {
    gsap.to(balance, {
      duration: 0.5,
      rotate: (mouseX - window.innerWidth / 2) / 100 + 'deg'
    })
    gsap.to(lines[0], {
      duration: 0.5,
      x: (mouseX - window.innerWidth / 2) / 20 + 'px'
    })
    gsap.to(lines[1], {
      duration: 0.5,
      x: -(mouseX - window.innerWidth / 2) / 20 + 'px'
    })
  }

  const tiltBalanceAuto = () => {
    const tl = gsap.timeline({
      repeat: -1,
      yoyo: true,
      defaults: { duration: 2, ease: 'power2.inOut' }
    })
    tl.to(balance, {
      rotate: '10deg'
    })
    tl.to(
      lines[0],
      {
        x: '2.604vw'
      },
      '<'
    )
    tl.to(
      lines[1],
      {
        x: '-2.604vw'
      },
      '<'
    )
    tl.to(balance, {
      rotate: '-10deg'
    })
    tl.to(
      lines[0],
      {
        x: '-2.604vw'
      },
      '<'
    )
    tl.to(
      lines[1],
      {
        x: '2.604vw'
      },
      '<'
    )
  }

  if (window.innerWidth <= 1024) {
    tiltBalanceAuto()
  } else {
    document.addEventListener('mousemove', (e) => tiltBalanceEl(e.layerX))
  }
}

export default () => {}
